import { createClient } from '@supabase/supabase-js';

// Single source of truth — there is no hardcoded Supabase URL in this repo.
// CRA injects these at dev/build time from .env / .env.local (restart dev server after edits).
// Deployed sites use the env vars configured in Vercel (etc.), not your local .env file.
const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const supabaseKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

if (process.env.NODE_ENV === 'development') {
  if (!supabaseUrl || !supabaseKey) {
    // eslint-disable-next-line no-console
    console.error(
      '[Deferredly] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. Check .env, then restart npm start.'
    );
  } else {
    try {
      const host = new URL(supabaseUrl).host;
      // eslint-disable-next-line no-console
      console.info(`[Deferredly] Supabase API host: ${host}`);
    } catch {
      // eslint-disable-next-line no-console
      console.warn('[Deferredly] REACT_APP_SUPABASE_URL is not a valid URL.');
    }
  }
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined
  }
});

// Database types
export interface Event {
  id: string;
  user_id?: string;
  title: string;
  description?: string;
  event_date: string;
  event_type: 'deadline' | 'info-session' | 'workshop' | 'other';
  school?: string;
  created_at?: string;
  updated_at?: string;
}

export interface EventInsert {
  title: string;
  description?: string;
  event_date: string;
  event_type: 'deadline' | 'info-session' | 'workshop' | 'other';
  school?: string;
}

export interface Profile {
  id?: string;
  user_id?: string;
  full_name?: string;
  academic_institution?: string;
  major_minor?: string;
  gpa?: number;
  gpa_scale?: string;
  gmat_score?: number;
  gre_score?: number;
  extracurriculars?: string;
  work_experience?: string;
  target_schools?: string[];
  // Career goals (replace "desired industries" UI)
  desired_outcomes?: string;
  why_mba?: string;

  // Kept for backward compatibility with any existing stored profiles
  desired_industries?: string[];
  created_at?: string;
  updated_at?: string;
}

export interface EmailSignup {
  id?: string;
  email: string;
  created_at?: string;
}

export interface ForumPost {
  id: string;
  user_id: string;
  author_label: string;
  title: string;
  body: string;
  created_at: string;
}

export interface ForumPostInsert {
  user_id: string;
  author_label: string;
  title: string;
  body: string;
}
